import { render, staticRenderFns } from "./ClientInvoices.vue?vue&type=template&id=af029168"
import script from "./ClientInvoices.vue?vue&type=script&lang=js"
export * from "./ClientInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports